import { Link } from "react-router-dom";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  icon?: string;
}

export default function SectionHeader({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看更多",
  icon = "ri-fire-line",
}: SectionHeaderProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div className="flex items-center gap-3">
        <span className="w-10 h-10 rounded-lg bg-primary-500/15 flex items-center justify-center shrink-0">
          <i className={`${icon} text-xl text-primary-400`} />
        </span>
        <div>
          <h2 className="font-heading text-lg md:text-2xl font-bold text-foreground-950">
            {title}
          </h2>
          {subtitle && (
            <p className="text-xs md:text-sm text-foreground-500 mt-0.5">{subtitle}</p>
          )}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 text-sm text-primary-300 hover:text-primary-200 transition-colors flex items-center gap-1 whitespace-nowrap cursor-pointer"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line" />
        </Link>
      )}
    </div>
  );
}